import { useNavigate } from 'react-router-dom';
import useContextualPathTransformer from '~/hooks/use-contextual-path-transformer';

const usePushTransformedPath = () => {
	const transformPath = useContextualPathTransformer();
	const navigate = useNavigate();

	const pushTransformedPath = (path: string, state?: Record<string, unknown>) => {
		navigate(transformPath(path, {}), { state });
	};

	return pushTransformedPath;
};

export default usePushTransformedPath;
